import { render, staticRenderFns } from "./BCXQuickLayer.vue?vue&type=template&id=4df67a0c&scoped=true"
import script from "./BCXQuickLayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXQuickLayer.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXQuickLayer.vue?vue&type=style&index=0&id=4df67a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df67a0c",
  null
  
)

export default component.exports